import Vue from 'vue';

export default Vue.extend({
  name: 'FlashMessage',

  data() {
    return {
      isVisible: true,
    };
  },

  methods: {
    hide() {
      this.isVisible = false;
    },

    show() {
      this.isVisible = true;
    },
  },
});



// WEBPACK FOOTER //
// ./src/js/components/flash-messages/index.js